import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { ILoggerService } from 'vscode/vscode/vs/platform/log/common/log.service';

const _moduleId = "vs/workbench/contrib/notebook/browser/services/notebookLoggingServiceImpl";
const logChannelId = 'notebook.rendering';
let NotebookLoggingService = class NotebookLoggingService extends Disposable {
    static { this.ID = 'notebook'; }
    constructor(loggerService) {
        super();
        this._logger = this._register(loggerService.createLogger(logChannelId, { name: ( localizeWithPath(_moduleId, 0, "Notebook rendering")) }));
    }
    debug(category, output) {
        this._logger.debug(`[${category}] ${output}`);
    }
    info(category, output) {
        this._logger.info(`[${category}] ${output}`);
    }
};
NotebookLoggingService = ( (__decorate([
    ( (__param(0, ILoggerService)))
], NotebookLoggingService)));

export { NotebookLoggingService };
